import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import {
  Button,
  TextField,
  FormControlLabel,
  FormGroup,
  Checkbox,
  FormControl,
  Select,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import "../components/AceternityForm/AceternityForm.css";
import {
  aceternityTextFieldSx,
  aceternitySelectSx,
  aceternityMenuPaperSx,
  aceternityCheckboxSx,
} from "../components/AceternityForm/aceternityTextFieldSx";
import BorderGlow from "../components/BorderGlow/BorderGlow";
import { useState } from "react";
import { registrarUsuario } from "../services/posUsers";
import { useNavigate } from "react-router-dom";

const bcrypt = require("bcryptjs");
const saltRounds = 12;

const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
const isValidTelefono = (telefono) => {
  // Solo números costarricenses: 8 dígitos, inicia en 2,4,5,6,7,8
  return /^[245678]\d{7}$/.test(telefono);
};

function checkValidDataSpaces(formData) {
  let allChecked = false;
  let nameData = formData.nombre.length > 0;
  let apellidoData = formData.apellidos.length > 0;
  let correoData = formData.correo.length > 0;
  let telefonoData = isValidTelefono(formData.telefono);
  let contrasena =
    formData.contrasena.length >= 8 &&
    formData.confirmContrasena === formData.contrasena;

  allChecked = nameData && apellidoData && correoData && telefonoData && contrasena;

  return allChecked;
}

const CreateAcc = () => {
  const [paginaExtraInfo, setPaginaExtraInfo] = useState("none");
  const [paginaBasica, setPaginaBasica] = useState("flex");
  const [esEstudiante, setEsEstudiante] = useState("none");

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    nombre: "",
    apellidos: "",
    contrasena: "",
    confirmContrasena: "",
    esEstudiante: "",
    carrera: "",
    carne: "",
    correo: "",
    telefono: "",
    direccion: "",
  });

  async function hashPassword(password) {
    try {
      const hash = await bcrypt.hash(password, saltRounds);
      return hash;
    } catch (error) {
      throw new Error("Error al encriptar la contraseña: " + error.message);
    }
  }

  const handleChangeEstudiante = (event) => {
    const isChecked = event.target.checked;

    // Actualizar visibilidad del bloque de estudiante
    setEsEstudiante(isChecked ? "flex" : "none");

    setFormData({
      ...formData,
      esEstudiante: isChecked ? "1" : "0",
      carrera: isChecked ? formData.carrera : "", // Se borra si no es estudiante
      carne: isChecked ? formData.carne : "", // Se borra si no es estudiante
    });
  };

  const carreras = ["Computadores", "Mecatrónica", "Electrónica", "Otra"];

  const handleEnterBasicInfo = () => {
    console.log(formData);
    if (checkValidDataSpaces(formData) && !emailError) {
      setPaginaBasica("none");
      setPaginaExtraInfo("flex");
    }
  };

  const handleReturnToBasics = () => {
    setPaginaBasica("flex");
    setPaginaExtraInfo("none");
  };

  const [emailError, setEmailError] = useState(false);
  const [telefonoError, setTelefonoError] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "correo") {
      setEmailError(!isValidEmail(value));
    }
    if (name === "telefono") {
      setTelefonoError(!isValidTelefono(value));
    }
  };

  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const handleConfirmOpen = () => {
    setOpenConfirmModal(true);
  };

  const handleConfirmClose = () => {
    setOpenConfirmModal(false);
    handleSubmit();
    navigate("/iniciar-sesion");
  };
  const handleSubmit = async () => {
    try {
      const hashedPassword = await hashPassword(formData.contrasena);

      const userData = {
        request_data: {},
        name: formData.nombre + " " + formData.apellidos,
        name_alias: formData.carne, //Carné
        client: "1",
        idprof1: hashedPassword, //Contraseña
        idprof2: formData.carrera, //Carrera
        email: formData.correo,
        phone: formData.telefono
      };
      await registrarUsuario(userData);
    } catch (error) {}
  };

  return (
    <>
      <Header />
      <div className="aceternity-form-page">
        <div className="aceternity-form-wrapper">
          <BorderGlow className="aceternity-glow-wrap" borderRadius={16} backgroundColor="transparent">
          <div className="aceternity-form-card">
            <h2 className="aceternity-form-title">Crea tu cuenta Volteon</h2>
            <p className="aceternity-form-subtitle">
              Con una cuenta Volteon, puedes realizar pedidos en línea, verificar el
              estado de tu compra, acceder a promociones... ¡Y mucho más!
            </p>

            <div className="aceternity-form" style={{ display: paginaBasica }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="aceternity-form-row">
                  <TextField
                    required
                    error={formData.nombre.length === 0}
                    id="TF-Nombre"
                    name="nombre"
                    label="Nombre"
                    value={formData.nombre}
                    onChange={handleInputChange}
                    variant="filled"
                    fullWidth
                    sx={aceternityTextFieldSx}
                  />
                </div>
                <div className="aceternity-form-row">
                  <TextField
                    required
                    error={formData.apellidos.length === 0}
                    id="TF-Apellidos"
                    name="apellidos"
                    label="Apellidos"
                    value={formData.apellidos}
                    onChange={handleInputChange}
                    variant="filled"
                    fullWidth
                    sx={aceternityTextFieldSx}
                  />
                </div>
                <div className="aceternity-form-row">
                  <TextField
                    required
                    error={emailError || formData.correo.length === 0}
                    helperText={emailError ? "Ingrese un correo válido" : ""}
                    id="TF-Correo"
                    name="correo"
                    label="Correo electrónico"
                    value={formData.correo}
                    onChange={handleInputChange}
                    variant="filled"
                    fullWidth
                    sx={aceternityTextFieldSx}
                  />
                </div>
                <div className="aceternity-form-row">
                  <TextField
                    required
                    error={telefonoError || formData.telefono.length === 0}
                    helperText={
                      telefonoError ? "Ingrese un número válido de Costa Rica" : ""
                    }
                    id="TF-Telefono"
                    name="telefono"
                    label="Teléfono"
                    value={formData.telefono}
                    onChange={handleInputChange}
                    variant="filled"
                    fullWidth
                    sx={aceternityTextFieldSx}
                  />
                </div>
                <div className="aceternity-form-row">
                  <TextField
                    required
                    error={formData.contrasena.length < 8}
                    id="standard-password-input"
                    name="contrasena"
                    label="Contraseña"
                    type="password"
                    autoComplete="current-password"
                    value={formData.contrasena}
                    onChange={handleInputChange}
                    variant="filled"
                    fullWidth
                    helperText={
                      formData.contrasena.length >= 8
                        ? ""
                        : "Las contraseñas deben ser de al menos 8 caracteres"
                    }
                    sx={aceternityTextFieldSx}
                  />
                </div>
                <div className="aceternity-form-row">
                  <TextField
                    required
                    error={
                      formData.confirmContrasena !== formData.contrasena ||
                      formData.contrasena.length < 8
                    }
                    id="standard-password-input-2"
                    name="confirmContrasena"
                    label="Contraseña (de nuevo)"
                    type="password"
                    autoComplete="current-password"
                    value={formData.confirmContrasena}
                    onChange={handleInputChange}
                    variant="filled"
                    fullWidth
                    helperText={
                      formData.confirmContrasena === formData.contrasena
                        ? ""
                        : "Las contraseñas deben coincidir"
                    }
                    sx={aceternityTextFieldSx}
                  />
                </div>
              </div>

              <button className="aceternity-btn-primary" onClick={handleEnterBasicInfo}>
                Verificar y continuar &rarr;
              </button>
            </div>

            <div className="aceternity-form" style={{ display: paginaExtraInfo }}>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox sx={aceternityCheckboxSx} onChange={handleChangeEstudiante} />}
                  label="¿Es estudiante Tec?"
                  sx={{ color: "rgba(255,255,255,0.85)" }}
                />
              </FormGroup>
              <div style={{ display: esEstudiante, flexDirection: "column" }}>
                <div className="aceternity-form-row">
                  <label className="aceternity-label">Carrera</label>
                  <FormControl fullWidth>
                    <Select
                      name="carrera"
                      value={formData.carrera}
                      onChange={handleInputChange}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      size="small"
                      sx={aceternitySelectSx}
                      MenuProps={{ PaperProps: { sx: aceternityMenuPaperSx } }}
                    >
                      {carreras.map((carrera, index) => (
                        <MenuItem key={index} value={carrera}>
                          {carrera}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className="aceternity-form-row">
                  <TextField
                    required
                    id="TF-Carnet"
                    name="carne"
                    label="Carné"
                    value={formData.carne}
                    onChange={handleInputChange}
                    variant="filled"
                    fullWidth
                    sx={aceternityTextFieldSx}
                  />
                </div>
              </div>

              <div style={{ display: "flex", gap: "1rem" }}>
                <button className="aceternity-btn-secondary" onClick={handleReturnToBasics}>
                  Volver
                </button>
                <button className="aceternity-btn-primary" onClick={handleConfirmOpen}>
                  Terminar &rarr;
                </button>
              </div>
            </div>
          </div>
          </BorderGlow>
        </div>
      </div>
      <Dialog
        open={openConfirmModal}
        onClose={handleConfirmClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirmar información de usuario"}
        </DialogTitle>
        <DialogContent style={{ padding: "40px" }}>
          <DialogContentText>
            Nombre: {formData.nombre} {formData.apellidos}
          </DialogContentText>
          <DialogContentText>Correo: {formData.correo}</DialogContentText>
          <DialogContentText style={{ display: esEstudiante }}>
            Carrera: {formData.carrera}
          </DialogContentText>
          <DialogContentText style={{ display: esEstudiante }}>
            Carnet: {formData.carne}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button>Volver</Button>
          <Button onClick={handleConfirmClose} autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
      <Footer />
    </>
  );
};

export default CreateAcc;
